module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "basic-text-frame"
  }, [_c('p', {
    staticClass: "copyright"
  }, [_c('span', {
    staticClass: "copyright1"
  })]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "credit1"
  }, [_vm._v("Co"), _c('a', {
    attrs: {
      "id": "x.276"
    }
  }), _vm._v("ntent Editor: ")]), _c('span', {
    staticClass: "credit1"
  }, [_vm._v("Caitlin Ridings")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "credit1"
  }, [_vm._v("Assistant Editor")]), _c('span', {
    staticClass: "credit1"
  }, [_vm._v(": Adriana Fitch")]), _c('span', {
    staticClass: "credit1"
  })]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "credit1"
  }, [_vm._v("Project Editor: ")]), _c('span', {
    staticClass: "credit1"
  }, [_vm._v("Sarah Bozone")]), _c('span', {
    staticClass: "credit1"
  })]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "credit1"
  }, [_vm._v("Graphic Design: ")]), _c('span', {
    staticClass: "credit1"
  }, [_vm._v("Chris Gilbert")]), _c('span', {
    staticClass: "credit1"
  })]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "credit1"
  }, [_vm._v("Cover Design: ")]), _c('span', {
    staticClass: "credit1"
  }, [_vm._v("Michael Buckingham")]), _c('span', {
    staticClass: "credit1"
  })]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_c('span', {
    staticClass: "copyright1"
  })]), _vm._v(" "), _c('p', {
    staticClass: "copyright2"
  }, [_c('span', {
    staticClass: "copyright1"
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('p', {
    staticClass: "italic-copyright"
  }, [_c('span', {
    staticClass: "itlaic-copyright"
  }, [_vm._v("Ann Hazelwood is a former shop owner and native of St. Charles Missouri. She's always adored quilting and is a certified quilt appraiser. She's the author of the wildly successful Colebridge Community series and considers writing one of her greatest passions. Titles include: Colebridge Community series - The Basement Quilt, The Potting Shed Quilt, The Funeral Parlor Quilt, The Jane Austen Quilt Club, The Ghostly Quilts on Main, Quilted Lilies, A Colebridge Quilted Christmas.  She has also published the Wine Country Quilt Series, East Perry County series and is now writing the Door County Quilt series.")]), _c('span', {
    staticClass: "copyright1"
  })]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_c('span', {
    staticClass: "copyright1"
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53916c15","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/forgiv_ebook1.vue
// module id = 63
// module chunks = 0